export const buildZoomId = (fileId: string, page: number = 0): string => `${fileId}-${page}`;

/**
 * Convert client-side zoom multiplier (1.5) to server-side percentage (150).
 */
export const toServerScale = (scale: number): number => Math.round(scale * 100);

/**
 * Convert server-side percentage (150) to client-side zoom multiplier (1.5).
 */
export const fromServerScale = (serverScale?: number): number =>
  serverScale ? serverScale / 100 : 1;
